import { memo, useContext, useMemo, useRef } from "react";

import HorizontalScrollButtons from '../../../components/HorizontalScrollWrapper/horizontalScrollWrapper'
import { Box, Divider } from "@mui/material";
import useStyles from "./styles";
import ChartDurations from "../chartDurations/ChartDurations";
import { AppContext } from "../../../App";
import ChartDrawingToolbar from "../chartDrawingToolbar/chartDrawingToolbar";
import { DrawingTypes } from "../drawingTools/drawing.interface";
import ChartReplayToolbar from "../chartReplayToolbar/chartReplayToolbar";
import { useSelector } from "react-redux";
import { selectChartReplayMode } from "../../../selectors/chart";
import { ReplayStatus } from "../../../reducer/chart.reducer";

export type ChartFooterProps = {
    activeChartId: string,
    disableDrawings?: boolean,
    disableTimeRange?: boolean,
    onDrawingClick: (drawingType: DrawingTypes, options: Record<string, any>, enter?: boolean) => void
}

const ChartFooter: React.FC<ChartFooterProps> = ({activeChartId, disableTimeRange, disableDrawings, onDrawingClick}) => {

    const appContext = useContext(AppContext)
    const containerRef = useRef<HTMLDivElement>(null)

    const {classes, cx} = useStyles()

    const replayState = useSelector(selectChartReplayMode)

    const showReplayBar = useMemo(() => {
        if (!replayState) return false;
        return [ReplayStatus.SELECTED, ReplayStatus.PLAYING].includes(replayState.status)
    }, [replayState])

    return  <HorizontalScrollButtons containerRef={containerRef}>
                <div className={classes.container}>
                    {showReplayBar && <div className={classes.topBar}>
                        <ChartReplayToolbar />
                        <Divider orientation="horizontal" className={classes.divider}/>
                    </div>}
                    <Box ref={containerRef} className={cx(classes.bottomBar, "horizontal-scroll-bar-container")}>
                        <ChartDurations disable={disableTimeRange} />
                        {appContext.getChart(activeChartId) && <ChartDrawingToolbar disable={disableDrawings} onDrawingClick={onDrawingClick} />}
                    </Box>
                </div>
            </HorizontalScrollButtons>
}
export default memo(ChartFooter);